(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-by-turbo"]) return;
  try {
    
  function removeDisable() {
    document.querySelectorAll('.ymp-buy-button').forEach((button) => {
      button.disabled = false;
      button.classList.remove('disabled');
    });
  }

  setInterval(removeDisable(), 1000);

  function defaultVariant() {
    document.querySelector('input[value="Páprica"]').click();
    document.querySelector('input[value="2"]').click();
  }
  defaultVariant();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-by-turbo"] && !window.DesignMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function clickLabels(label) {
    const alltabs = document.querySelectorAll('.blog-articles .article');
    const showtab = label.getAttribute('for');
    const tabs = document.querySelectorAll(`.${showtab}`);
    if (showtab == 'Todas') {
      alltabs.forEach((taball) => {
        taball.style.display = 'flex';
      });
    } else {
      alltabs.forEach((taball) => {
        taball.style.display = 'none';
      });

      tabs.forEach((tab) => {
        tab.style.display = 'flex';
      });
    }
  }

  const labelArr = Array.from(document.querySelectorAll('.main-blog .tabs__label'));

  labelArr.forEach((label) => {
    label.addEventListener('click', () => clickLabels(label));
  });

  const selectedInput = document.querySelector('input[type="radio"][name="tabs-receitas"]:checked');
  const selectedLabel = document.querySelector(`label[for="${selectedInput.id}"]`);
  clickLabels(selectedLabel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-old"] && !window.DesignMode) return;
  try {
    

  function variantChanges() {
    const selectedFlavor = document.querySelector('input[name="Sabores"]:checked');
    console.log('flavor', selectedFlavor.value);
    const selectedUnity = document.querySelector('input[name="Unidades"]:checked').value;
    const bg = document.querySelector(".product-bg-gradient");
    const lineMB = document.querySelector(".product-wave svg:last-child path:last-child");
    const line = document.querySelector(".product-wave svg:first-child path:last-child");
    const variantTitle = document.querySelector(".title--variant");
    const labelArr = Array.from(document.querySelectorAll("label.product-input__label"));
    const input1 = document.querySelector('input[value="1"]');
    const label1 = document.querySelector(`label[for="${input1.id}"]`);
    
    function clickPaprica() {
      document.querySelector('input[value="Páprica"]').click();
    }

    if(selectedFlavor.value == 'Ambos') {
      label1?.addEventListener("click", clickPaprica);
    } else {
      label1?.removeEventListener("click", clickPaprica);
    }

    labelArr.forEach((label) => {    
      let labelInText = label.children[0].innerText.normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ")[0].toLowerCase().trim();  

      if(labelInText === "paprica") {
        //add "mais vendido" tag on "Páprica" flavor
        if(!label.children[1]) {
          const div = document.createElement('div');
          div.textContent = 'Mais vendido';  
          div.classList.add('mais-vendido-sticker'); 
          label.appendChild(div);
        }
        //update "2x" or "1x" suffix of variant label acordding to unity selected
        label.children[0].innerText = `Páprica ${selectedUnity}x`;
      } else if(labelInText === 'original') {
        label.children[0].innerText = `Original ${selectedUnity}x`;
      } else if(labelInText === 'ambos') {
        //hide "Ambos" flavor when 1 unity is selected
        if (selectedUnity == 1) {
          label.style.display = 'none';
        } else {
          label.style.display = 'flex';
        }
      }
    })
    
    //changes background gradient, line color and variant title
    if (selectedFlavor.value == 'Ambos') {
      bg.style.background = `linear-gradient(180deg, #000000 0%, #7F4127 100%)`;
      lineMB.style.stroke = '#7F4127';
      line.style.stroke = '#7F4127';
      variantTitle.innerText = selectedFlavor.value;
    } else {
      variantTitle.innerText = `${selectedFlavor.value} ${selectedUnity}x`;
      if (selectedFlavor.value == "Original") {
        bg.style.background = `linear-gradient(180deg, #1E1E1E 0%, #ED6F4E 100%)`;
        lineMB.style.stroke = '#8C3628';
        line.style.stroke = '#8C3628';
      } else if (selectedFlavor.value == "Páprica") {
        bg.style.background = `linear-gradient(180deg, #1E1E1E 0%, #8C3628 100%)`;
        lineMB.style.stroke = '#ED6F4E';
        line.style.stroke = '#ED6F4E';
      }
    }

    //change image

    const mediaImages = Array.from(document.querySelectorAll('.product-media-item'));
    const mainImage = document.querySelector('.main-product__media-image'); 
    
    mediaImages.forEach(mediaImage => {
      mediaImage.classList.remove('current-media');
      if(mediaImage.id.indexOf(window.location.href.split('variant=')[1]) > -1) {
        const img = mediaImage.querySelector('img');
        mainImage.src = img.src;
        mainImage.srcset = img.srcset;
        mediaImage.classList.add('current-media');
      }
    });
  };

  window.onload = () => {
    const unity_2 = document.querySelector('input[value="2"]')
    if(window.location.href.split('=').length == 1) {
      unity_2.click();
    }
    variantChanges();

    let previousUrl = '';
    const observer = new MutationObserver(function(mutations) {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href;
        variantChanges();
      }
    });
    const config = {subtree: true, childList: true};
    // start listening to changes
    observer.observe(document, config);
  };
    
  const mainImage = document.querySelector('.main-product__media-image'); 

  let initialX, initialY;
  let timerId = null;

  mainImage.addEventListener("touchmove", (event) => {
    const touch = event.touches[0];
    const deltaX = touch.clientX - initialX;   
    
    if (deltaX > 0) {
      clearTimeout(timerId);  
      timerId = setTimeout(() => setSelected(-1), 500); 
    } else if (deltaX < 0) {
      clearTimeout(timerId);
      timerId = setTimeout(() => setSelected(1), 500);
    } 
  }); 

  mainImage.addEventListener("touchstart", (event) => {
    const touch = event.touches[0]; 
    initialX = touch.clientX;  
    clearTimeout(timerId);
  }, false); 
  
  const mediaImages = Array.from(document.querySelectorAll('.product-media-item'));
  const mediaImagesList = document.querySelector('.main-product__media-items');
  if (mediaImages.length > 0) {
    mediaImages[0].classList.add('current-media');
    mediaImages.forEach(mediaImage => {
      mediaImage.addEventListener('click', () => {
        const img = mediaImage.querySelector('img');
        mainImage.src = img.src;
        mainImage.srcset = img.srcset;
        mediaImages.forEach(mediaImage => mediaImage.classList.remove('current-media'));
        mediaImage.classList.add('current-media');
      });
    });
  }; 

  function setSelected(i) {
    let current = mediaImages.findIndex(image => image.classList.contains("current-media"));
    if (current + i >= mediaImages.length) {
      mediaImages[0].click();
    } else if (current + i < 0) {
      mediaImages[mediaImages.length - 1].click()
    } else {
      mediaImages[current + i].click();
    }
  }
  
  const prevButton = document.querySelector(".media-item-prev");
  const nextButton = document.querySelector(".media-item-next");
  prevButton?.addEventListener('click', () => setSelected(-1));
  nextButton?.addEventListener('click', () => setSelected(1));

  if (mediaImagesList) {
    new Glider(document.querySelector('.main-product__media-items'), {
      slidesToShow: 'auto',
      slidesToScroll: 1,
      scrollLock: true,
      itemWidth: 45,
      arrows: {
        prev: '.media-item-prev',
        next: '.media-item-next',
      }
    })
  }
  
  const modalSabor = document.getElementById("modal-novo-sabor");
  const modalPrimMao = document.getElementById("modal-primeira-mao");
  const btn = document.getElementById("newProductOptionsButton");
  btn.addEventListener("click", () => {
    modalSabor.style.display = "flex";
  })

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const openModal = urlParams.get('modalOpen');
  if (openModal == true) {
    btn.click();
  }

  const sugestaoSaborInput = document.querySelector("#sugestao-sabor");
  const sendButton = document.querySelector("#novo-sabor-button");
  if (sugestaoSaborInput) {
    sugestaoSaborInput.addEventListener(
      "input", (e) => {
        const options = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
        if(sugestaoSaborInput.value.length > 0) {
          options[0].value = `outro, ${e.target.value}`;
          sendButton.disabled = false;
        } else {
          sendButton.disabled = true;
        }
      } 
    );
  }
  if (sendButton) {
    sendButton.addEventListener("click", (event) => {
      let checked = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
      if (checked[0].id === 'novo-sabor-opcao3') {
        const sugestaoTexto = sugestaoSaborInput.value
        modalSabor.style.display = "none";
        modalPrimMao.style.display = "flex";
      } else {
        modalSabor.style.display = "none";
        modalPrimMao.style.display = "flex";
      }
      event.stopPropagation();
    })
  }

  const fechaModalSabor = document.getElementById('novo-sabor-body');
  const fechaModalPrim = document.getElementById('primeira-mao-body');
  window.onclick = function(event) {
    if (event.target == fechaModalSabor || event.target == fechaModalPrim) {
      modalSabor.style.display = "none";
      modalPrimMao.style.display = "none";
    }
  }

  const formSaboresInputs = Array.from(document.querySelectorAll('input[name="contact[tags]"]'));
  formSaboresInputs.forEach(input => {
    input.addEventListener("click", (event) => {
      var checked = document.querySelectorAll('input[name="contact[tags]"]:checked');
      sendButton.disabled = true;
      sugestaoSaborInput.disabled = true;
      if (checked.length > 0) {
        if (event.target.id === "novo-sabor-opcao3") {
          sugestaoSaborInput.disabled = false;
        } else {
          sendButton.disabled = false;
        }
      } 
    })
  })

  const emailTextInput = document.querySelector("#primeira-mao-email")
  emailTextInput.addEventListener(
    "keyup", () => {
      if(document.getElementById("primeira-mao-email").value !== "") {
        document.querySelector("#primeira-mao-button").disabled = false;
      } else {
        document.querySelector("#primeira-mao-button").disabled = true;
      }
    } 
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modo-de-preparo"] && !window.DesignMode) return;
  try {
    
    
    function clickLabel(label) {
        const alltabs = document.querySelectorAll('.tabs__content__card');
        const showtab = label.getAttribute("for");
        const tabs = document.querySelectorAll(`.${showtab}`);
        
        alltabs.forEach((taball) => {
            taball.style.display = "none";
        });

        tabs.forEach((tab) => {
            tab.style.display = "flex";
        })
    };

    const labelArr = Array.from(document.querySelectorAll(".tabs__label"));   

    labelArr.forEach((label) => {    
        label.addEventListener("click", () => clickLabel(label));
    });

    const selectedInput = document.querySelector('input[type="radio"][name="tabs-preparo"]:checked');
    const selectedLabel = document.querySelector(`label[for="${selectedInput.id}"]`);
    clickLabel(selectedLabel);

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !window.DesignMode) return;
  try {
    
  const modalSabor = document.getElementById('modal-novo-sabor');
  const modalPrimMao = document.getElementById('modal-primeira-mao');
  const btn = document.getElementById('newProductOptionsButton');
  btn.addEventListener('click', () => {
    modalSabor.style.display = 'flex';
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const openModal = urlParams.get('modalOpen');
  if (openModal == true) {
    btn.click();
  }

  const sugestaoSaborInput = document.querySelector('#sugestao-sabor');
  const sendButton = document.querySelector('#novo-sabor-button');

  sugestaoSaborInput.addEventListener('input', (e) => {
    const options = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
    if (sugestaoSaborInput.value.length > 0) {
      options[0].value = `outro, ${e.target.value}`;
      sendButton.disabled = false;
    } else {
      sendButton.disabled = true;
    }
  });

  sendButton.addEventListener('click', (event) => {
    let checked = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
    if (checked[0].id === 'novo-sabor-opcao3') {
      const sugestaoTexto = sugestaoSaborInput.value;
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'flex';
    } else {
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'flex';
    }
    event.stopPropagation();
  });

  const fechaModalSabor = document.getElementById('novo-sabor-body');
  const fechaModalPrim = document.getElementById('primeira-mao-body');
  window.onclick = function (event) {
    if (event.target == fechaModalSabor || event.target == fechaModalPrim) {
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'none';
    }
  };

  const formSaboresInputs = Array.from(document.querySelectorAll('input[name="contact[tags]"]'));
  formSaboresInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
      var checked = document.querySelectorAll('input[name="contact[tags]"]:checked');
      sendButton.disabled = true;
      sugestaoSaborInput.disabled = true;
      if (checked.length > 0) {
        if (event.target.id === 'novo-sabor-opcao3') {
          sugestaoSaborInput.disabled = false;
        } else {
          sendButton.disabled = false;
        }
      }
    });
  });

  const emailTextInput = document.querySelector('#primeira-mao-email');
  emailTextInput.addEventListener('keyup', () => {
    if (document.getElementById('primeira-mao-email').value !== '') {
      document.querySelector('#primeira-mao-button').disabled = false;
    } else {
      document.querySelector('#primeira-mao-button').disabled = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-by-turbo"] && !window.DesignMode) return;
  try {
    
  const reviewCards = document.querySelectorAll('.review-card');
  reviewCards.forEach((card) => {
    const order3 = card.querySelector('.order-3');
    const order2 = card.querySelector('.order-2');

    if (
      order3 &&
      ((order3.classList.contains('client-review') && order2.classList.contains('client-info')) ||
        (order3.classList.contains('client-info') && order2.classList.contains('client-review')))
    ) {
      order2.style.marginTop = 'auto';
    } else if (order3 && !order3.classList.contains('client-message')) {
      order3.style.marginTop = 'auto';
    } else {
      if (!order2.classList.contains('client-message')) {
        order2.style.marginTop = 'auto';
      }
    }
  });

  const child = document.querySelector('.swiper-slide-active');
  const parent = child.parentNode;
  const children = Array.from(parent.children);
  const index = Array.prototype.indexOf.call(children, child);

  children.forEach((child2) => {
    const childIndex = Array.prototype.indexOf.call(children, child2);
    if (childIndex > index) {
      child2.style.alignItems = 'end';
    } else if (childIndex < index) {
      child2.style.alignItems = 'start';
    } else {
      child2.style.alignItems = 'center';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
